import React, { useState, useEffect } from 'react';
import { Box, Card, CardContent, Typography, useMediaQuery, Button, Dialog, Divider, DialogTitle, DialogContent, DialogContentText, DialogActions, Checkbox, CircularProgress} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { collection, onSnapshot, doc, getDocs,setDoc, writeBatch, deleteDoc, updateDoc, addDoc, query, where } from 'firebase/firestore';
import { DndProvider, useDrag, useDrop } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';

import {db} from '../../firebaseConfig';

import {generateUniqueId} from '../../common/ItemNumberGenerator'; 

import CustomerFeedbackInputModal from './CustomerFeedbackInputModal';
import CustomerFeedbackDrawerModal from './CustomerFeedbackDrawerModal';
import { tokens } from '../../theme';
import Header from '../../components/Header';
import { IconButton, Menu, MenuItem} from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';

import EditIcon from '@mui/icons-material/EditOutlined';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import FileCopyIcon from '@mui/icons-material/FileCopyOutlined';

import { logToast } from '../../common/ToastMessageLogger';

import noRecordImage from './no_customerfeedbacks.png'; //All Lowercase with underscore

import Tile from './CustomerFeedbackTile';

import { useUser } from "../../common/UserContext";
import { useApplicationMode } from "../../common/ApplicationModeContext";

const generateStatusColorMap = (customerFeedbacks,theme) => {
  
        const statusColorMap = {};
        
        const colorFunction = theme.palette.mode === "dark" ? stringToColorDark : stringToColorLight;

        customerFeedbacks.forEach(customerFeedback => {
          if (!statusColorMap[customerFeedback.status]) {
            statusColorMap[customerFeedback.status] = colorFunction(customerFeedback.status);
          }
        });
      
        return statusColorMap;
      };
      
 

const stringToColorLight = (str) => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  let color = '#';
  for (let i = 0; i < 3; i++) {
    const value = (hash >> (i * 8)) & 0xFF;
    // Ensuring that the color values are always light by adding a base value of 127
    const lightValue = ((value + 127) % 128) + 127;
    color += ('00' + lightValue.toString(16)).substr(-2);
  }
  return color;
};


const stringToColorDark = (str) => {
  return stringToColorLight(str);
};

const stringToColorDarkOLD = (str) => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  let color = '#';
  for (let i = 0; i < 3; i++) {
    const value = (hash >> (i * 8)) & 0xFF;
    // Ensuring that the color values are always dark by restricting them to the first half of 256
    const darkValue = value % 128;
    color += ('00' + darkValue.toString(16)).substr(-2);
  }
  return color;
};


const formatFirestoreDate = timestamp => {

  if (timestamp != null && timestamp !== "")
  {
    const dateStr = new Date(timestamp.seconds * 1000).toISOString().slice(0, 10);
    const parts = dateStr.split('-');
    return `${parts[1]}/${parts[2]}/${parts[0]}`;
  } else 
  {
    return "";
  }
};

const formatFirestoreTime = timestamp => {

 if (timestamp != null && timestamp !== "")
 { 
      // Convert the seconds since Unix epoch to a Date object
    const date = new Date(timestamp.seconds * 1000);

    // Extract hours and minutes
    let hours = date.getHours();
    const minutes = date.getMinutes();

    // Determine AM or PM
    const period = hours >= 12 ? 'PM' : 'AM';

    // Convert hours to 12-hour format
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'

    // Format hours and minutes as a time string in "hh:mm AM/PM" format
    const formattedHours = hours.toString().padStart(2, '0');
    const formattedMinutes = minutes.toString().padStart(2, '0');

    return `${formattedHours}:${formattedMinutes} ${period}`;
 } else
 {
  return "";
 }
};


const formatPhoneNumber = value => {
  if (!value) return value;
  const phoneNumber = value.replace(/[^\d]/g, '');
  const phoneNumberLength = phoneNumber.length;
  if (phoneNumberLength < 4) return phoneNumber;
  if (phoneNumberLength < 7) return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
  return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`;
};

const formatCurrencyInteger = value => {

  if (value != null && value !=="")
  {
    return `$${Number(value).toLocaleString()}`;
  } else 
  {
    return "";
  }
};

const formatCurrency = (value) => {

  if (value != null && value !=="")
  {
        value = value.toString();
        // Remove all non-numeric characters except for the decimal point
        let result = value.replace(/[^0-9.]/g, '');
      
        // If there are multiple decimal points, keep only the first one
        const parts = result.split('.');
        if (parts.length > 2) {
          result = parts[0] + '.' + parts.slice(1).join('');
        }
      
        // Allow at most two decimal places
        if (parts.length === 2 && parts[1].length > 2) {
        
          result = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1].substring(0, 2);
        } else if (parts.length === 2 && parts[1].length <= 2) 
        {
          result = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
        }else
        {
          result = result.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        }
        return result ? `$${result}` : '';

    } else 
    {
      return "";
    }
};



const ItemType = {
  CARD: 'card',
};

const DraggableCard = ({ customerFeedback, index, moveCard, status, setEditingCustomerFeedback, setDeleteId, setConfirmOpen, customerFeedbacks, setShowModal, colors,theme,deleteSelectionModel,setDeleteSelectionModel,setEditingData,handleDeleteSingleItem,setDrawerOpen ,customerMap, formatCustomer,statusColorMap }) => {
  const [, ref] = useDrag({
    type: ItemType.CARD,
    item: { id: customerFeedback.id, index, status },
  });

    const handleDeleteSelectionChange = (id) => {
   
      setDeleteSelectionModel((prev) =>
        prev.includes(id) ? prev.filter((itemId) => itemId !== id) : [...prev, id]
      );
  };



  const GridActionsCellItem = ({ id }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
      event.stopPropagation();  // Stop the event propagation
      setAnchorEl(event.currentTarget);
    };

    const handleClose = () => { setAnchorEl(null); setEditingCustomerFeedback(null); };
    const handleDeleteAction = () => { handleDeleteSingleItem(id); };
    const handleEditAction = () => { setEditingCustomerFeedback(customerFeedbacks.find(customerFeedback => customerFeedback.id === id)); setShowModal(true); };
    const handleCloneAction = () => {
      const customerFeedbackToEdit = customerFeedbacks.find(customerFeedback => customerFeedback.id === id);
      const clonedCustomerFeedback = { ...customerFeedbackToEdit, id: null, name: `${customerFeedbackToEdit.name} CLONED` };
      setEditingCustomerFeedback(clonedCustomerFeedback);
      setShowModal(true);
    };

    return (
      <>
        <IconButton aria-label="more" id="long-button" aria-controls={open ? 'long-menu' : undefined} aria-expanded={open ? 'true' : undefined} aria-haspopup="true" onClick={handleClick}>
          <MoreVertIcon />
        </IconButton>
        <Menu id="long-menu" MenuListProps={{ 'aria-labelledby': 'long-button', sx: { backgroundColor: colors.greenAccent[700] , color: colors.grey[100] } }} anchorEl={anchorEl} open={open} onClose={handleClose}>
          <MenuItem onClick={handleCloneAction}><FileCopyIcon style={{ marginRight: 8 }} /> Clone Customer Feedback</MenuItem>
          <MenuItem onClick={handleDeleteAction}><DeleteIcon style={{ marginRight: 8 }} /> Delete Customer Feedback</MenuItem>
          <MenuItem onClick={handleEditAction}><EditIcon style={{ marginRight: 8 }} /> Edit Customer Feedback</MenuItem>
        </Menu>
      </>
    );
  };
  
  const handleEditAction = (id) => { setEditingCustomerFeedback(customerFeedbacks.find(customerFeedback => customerFeedback.id === id)); setShowModal(true); };

  const handleOpenDrawer = (id) => {
  
    setEditingData(customerFeedbacks.find(dataItem=> dataItem.id === id)); 
    setDrawerOpen(true);
    setShowModal(false);

  };

  return (
    <Card ref={ref} sx={{marginBottom: 2,backgroundColor: colors.dragAndDropDrop.tileBackgroundColor,marginLeft: '9px',marginRight: '9px',
      '&:hover': {
        backgroundColor: colors.dragAndDropDrop.tileBackgroundColorHover, 
      },
    }}
    >
      <CardContent>
  
      <Typography variant="h5" sx={{fontWeight:'800', cursor: 'pointer' }}  onClick={() => handleEditAction(customerFeedback.id)}>{formatCustomer(customerFeedback.customerId)}</Typography>
       

        <table style={{width:'100%'}}>
          <tr>
            <td> 
            <Typography variant="h7" sx={{fontWeight:'500', cursor: 'pointer', color:'#898580' }}  onClick={() => handleEditAction(customerFeedback.id)}>{customerFeedback.customerFeedbackNumber}</Typography>
            </td>
            <td>  
              <span style={{float:"right"}}>
              <IconButton onClick={() => handleOpenDrawer(customerFeedback.id)}>
                  <KeyboardDoubleArrowRightIcon/>
              </IconButton>
              </span>
            </td></tr></table>
          

        <Typography variant="body2" sx={{paddingTop:'5px',paddingBottom:'5px'}}>{customerFeedback.feedbackDetails.length > 200 ? customerFeedback.feedbackDetails.substring(0, 200) + '...' : customerFeedback.feedbackDetails}</Typography>
        
        <table style={{width:'100%'}} cellSpacing={10}>
          <tr>
            <td style={{borderBottom: '1px solid #626262'}}>
              FEEDBACK DATE
            </td>
            <td style={{borderBottom: '1px solid #626262'}}>
              FOLLOW-UP DATE
            </td>
          </tr>
          <tr>
            <td>
               <Typography variant='h6' sx={{fontWeight:'600'}}>
{formatFirestoreDate(customerFeedback.feedbackDate)}</Typography>

            </td>
            <td>
               <Typography variant='h6' sx={{fontWeight:'600'}}>
{formatFirestoreDate(customerFeedback.followupDate)}</Typography>

            </td>
          </tr>
        </table>

        <div style={{textAlign:'center'}}>
         <Typography variant='h6' sx={{fontWeight:'600'}}>

                    <Box
                                key={customerFeedback.status}
                                sx={{ 
                                    backgroundColor: statusColorMap[customerFeedback.status], 
                                    borderRadius: '13px', 
                                    padding: '2px 8px', 
                                    display: 'inline-block', 
                                    marginRight: '4px',
                                    marginBottom: '4px',
                                    color: theme.palette.mode === "dark" ? '#000000' : '#000000',
                                    fontWeight:'600'  
                                }}
                                >
                                    { customerFeedback.status }

                                </Box>
                    </Typography>

        </div>

        <Box sx={{ padding: '0px', margin: '0px', height: '5px' }}>
              <div style={{ float: 'left' }}>

              <Checkbox 
              checked={deleteSelectionModel.includes(customerFeedback.id)}
              onChange={() => handleDeleteSelectionChange(customerFeedback.id)}
                                    
                                    sx={{
                                        color: theme.palette.mode === "dark" ? colors.greenAccent[600] : colors.greenAccent[400],
                                        '&.Mui-checked': {
                                        color: theme.palette.mode === "dark" ? colors.greenAccent[600] : colors.greenAccent[400],
                                        },
                                    }}
                                    />

              </div>
        </Box>     
        <Box sx={{ padding: '0px', margin: '0px', height: '20px' }}>

              <div style={{ float: 'right' }}>
                <GridActionsCellItem {...customerFeedback} />
              </div>
        </Box>
      </CardContent>
    </Card>
  );
};


const CustomerFeedbacks = ({ searchTerm }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const [customerFeedbacks, setCustomerFeedbacks] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editingCustomerFeedback, setEditingCustomerFeedback] = useState(null);
  const [loading, setLoading] = useState(true);

  const [collectionModalOpen, setCollectionModalOpen] = useState(false);
  const [missingCollections, setMissingCollections] = useState([]);

  const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
  const [deleteSelectionModel, setDeleteSelectionModel] = useState([]);
  const [deleteAlertOpen, setDeleteAlertOpen] = useState(false);

  const [selectedIdsToDelete, setSelectedIdsToDelete] = useState([]);
  const [selectedIdsNotToDelete, setSelectedIdsNotToDelete] = useState([]);

  const { appUserAccountNumber } = useUser();
  const { applicationMode } = useApplicationMode(); 

  const [pending, setPending] = useState([]);
const [reviewed, setReviewed] = useState([]);
const [resolved, setResolved] = useState([]);


  const [deleteId, setDeleteId] = useState(null);
  const [confirmOpen, setConfirmOpen] = useState(false);

  const [dependenciesAlertOpen, setDependenciesAlertOpen] = useState(false);

  const [deletionDependencies, setDeletionDependencies] = useState([]);

  const [processing, setProcessing] = useState(false);
  
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [selectedRowIndex, setSelectedRowIndex] = useState(0);

  const [selectedCustomerFeedback, setSelectedCustomerFeedback] = useState(null);

  const tilesDisplayCount = 6;

  const [visibleCount, setVisibleCount] = useState(tilesDisplayCount);

  const [showTestModeDialog, setShowTestModeDialog] = useState(false);

  const [suppressTestModeWarning, setSuppressTestModeWarning] = useState(
    localStorage.getItem('suppressTestModeSaveWarning') === 'true'
  );

  const [customerMap, setCustomerMap] = useState({});


  const [statusColorMap, setStatusColorMap] = useState({});


  
    useEffect(() => {
        const fetchStaticData = async () => {
            	const customerSnapshot = await getDocs(query(collection(db, "customers"), where("appAccountNumber", "==", appUserAccountNumber),where("applicationMode", "==", applicationMode)));
	const customerData = customerSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
	const customerMap = customerData.reduce((acc, ref) => ({ ...acc, [ref.id]: ref.firstName+ " " +ref.lastName }), {});
	setCustomerMap(customerMap);



            if (customerData.length === 0) {
	let missing = [];
	if (customerData.length === 0) missing.push("customers");
	setMissingCollections(missing);
	setCollectionModalOpen(true);
}

        };
    
        fetchStaticData();
      }, [appUserAccountNumber, applicationMode]);
    
    

  const columns = [
	{ field: "customerId", headerName: "Customer"},
	{ field: "productId", headerName: "Product"},
	{ field: "feedbackDate", headerName: "Feedback Date"},
	{ field: "feedbackType", headerName: "Feedback Type"},
	{ field: "feedbackDetails", headerName: "Feedback Details"},
	{ field: "requestedRefund", headerName: "Customer Requested Refund"},
	{ field: "followupRequired", headerName: "Follow-up Required"},
	{ field: "followupDate", headerName: "Follow-up Date"},
	{ field: "followupNotes", headerName: "Follow-up Notes"},
	{ field: "status", headerName: "Status"},
	{ field: "customerFeedbackNumber", headerName: "customerFeedbackNumber"},
	{ field: "id", headerName: "id"},
];



  useEffect(() => {

      if (!appUserAccountNumber) return; // Ensure appUserAccountNumber is available

      const customerFeedbacksRef = collection(db, "customerFeedbacks");
      const customerFeedbacksQuery = query(customerFeedbacksRef, 
        where("appAccountNumber", "==", appUserAccountNumber),
        where("applicationMode", "==", applicationMode)
      );
    
      const unsubscribe = onSnapshot(customerFeedbacksQuery, (snapshot) => {
        const customerFeedbacksData = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));

      setCustomerFeedbacks(customerFeedbacksData);
    
      /*
      const filteredCustomerFeedbacks = customerFeedbacksData.filter(customerFeedback =>
        columns.some(column => customerFeedback[column.field] && customerFeedback[column.field].toString().toLowerCase().includes(searchTerm.toLowerCase()))
      );
      */

      const filteredCustomerFeedbacks = customerFeedbacksData.filter(customerFeedback =>
        columns.some(column => {
            let value = customerFeedback[column.field];
    
            let matchFound = value && value.toString().toLowerCase().trim().includes(searchTerm.toLowerCase().trim());

            if (matchFound == false)
            {
              if (column.field.endsWith('Id')) {
                  const formatFunctionName = 'format' + column.field.replace(/Id$/, '').replace(/^\w/, c => c.toUpperCase());
    
                  try
                  {
                    value = eval(`${formatFunctionName}("${value}")`);
                    matchFound = value && value.toString().toLowerCase().trim().includes(searchTerm.toLowerCase().trim());
                  } catch(errr){}
              }
            }
    
            return matchFound;
    
        })
      );

      setPending(filteredCustomerFeedbacks.filter(cr => cr.status === 'Pending'));
setReviewed(filteredCustomerFeedbacks.filter(cr => cr.status === 'Reviewed'));
setResolved(filteredCustomerFeedbacks.filter(cr => cr.status === 'Resolved'));


      setStatusColorMap(generateStatusColorMap(customerFeedbacksData,theme));


      setLoading(false);
    }, (error) => {
      setLoading(false);
      alert("Error fetching customerfeedbacks: ", error);
    });

    return () => unsubscribe();
  }, [appUserAccountNumber,applicationMode]);

  useEffect(() => {
   
    /*
    const filteredCustomerFeedbacks = customerFeedbacks.filter(customerFeedback =>
      columns.some(column => customerFeedback[column.field] && customerFeedback[column.field].toString().toLowerCase().includes(searchTerm.toLowerCase()))
    );
    */

    const filteredCustomerFeedbacks = customerFeedbacks.filter(customerFeedback =>
      columns.some(column => {
          let value = customerFeedback[column.field];
  
          if (column.field.endsWith('Id')) {
              const formatFunctionName = 'format' + column.field.replace(/Id$/, '').replace(/^\w/, c => c.toUpperCase());
  
              try
              {
                value = eval(`${formatFunctionName}("${value}")`);
              } catch(errr){}
          }
  
          return value && value.toString().toLowerCase().includes(searchTerm.toLowerCase());
      })
    );


    setPending(filteredCustomerFeedbacks.filter(cr => cr.status === 'Pending'));
setReviewed(filteredCustomerFeedbacks.filter(cr => cr.status === 'Reviewed'));
setResolved(filteredCustomerFeedbacks.filter(cr => cr.status === 'Resolved'));


}, [searchTerm]);


  //USE EFFECT TO CHANGE COLOR MAP when it changes
useEffect(() => {
  setStatusColorMap(generateStatusColorMap(customerFeedbacks,theme));

}, [theme.palette.mode, customerFeedbacks]);



  
 const formatCustomer = value => {

    let formattedCustomer = "";

    if (value != null && value !=="")
    {
    formattedCustomer = customerMap[value];
    }
    
    return formattedCustomer;
 };
    
                


   
  
  const moveCard = (item, toIndex, newStatus) => {
    const fromList = getList(item.status);
    const toList = getList(newStatus);
    const [movedCard] = fromList.splice(item.index, 1);

    if (item.status !== newStatus) {
      movedCard.status = newStatus;
      toList.splice(toIndex, 0, movedCard);
    } else {
      fromList.splice(toIndex, 0, movedCard);
    }

    setList(item.status, fromList);
    setList(newStatus, toList);
    updateStatus(movedCard, newStatus);
  };

  const getList = (status) => {
    switch (status) {
      case 'Pending':
return pending;
case 'Reviewed':
return reviewed;
case 'Resolved':
return resolved;

      default:
        return [];
    }
  };

  const setList = (status, list) => {
    switch (status) {
      case 'Pending':
setPending(list);
case 'Reviewed':
setReviewed(list);
case 'Resolved':
setResolved(list);

        break;
      default:
        break;
    }
  };

  const updateStatus = (customerFeedback, newStatus) => {
    if (!customerFeedback || !customerFeedback.id) {
      console.error("Invalid change request: ", customerFeedback);
      return;
    }

    const customerFeedbackRef = doc(db, "customerFeedbacks", customerFeedback.id);
    updateDoc(customerFeedbackRef, { status: newStatus })
      .then(() => {
        console.log("Document successfully updated!");
      })
      .catch((error) => {
        console.error("Error updating document: ", error);
      });
  };


  const handleOpenModal = () => { setEditingCustomerFeedback(null); setShowModal(true); };
  
  const handleSaveCustomerFeedback = (customerFeedback) => {
    if (editingCustomerFeedback && editingCustomerFeedback.id) {
      setCustomerFeedbacks(prevCustomerFeedbacks => prevCustomerFeedbacks.map(c => c.id === customerFeedback.id ? customerFeedback : c));
      saveCustomerFeedbackToDB(customerFeedback);
    } else {
      setCustomerFeedbacks(prevCustomerFeedbacks => [...prevCustomerFeedbacks, { ...customerFeedback, id: prevCustomerFeedbacks.length + 1 }]);
      addCustomerFeedbackToDB(customerFeedback);
    }
    setShowModal(false);
    setEditingCustomerFeedback(null);

    if (applicationMode === 'test' && !suppressTestModeWarning) {
      setShowTestModeDialog(true);
    }
  };

  const saveCustomerFeedbackToDB = async (customerFeedback) => {
    const customerFeedbackRef = doc(db, "customerFeedbacks", customerFeedback.id);
    await updateDoc(customerFeedbackRef, customerFeedback);
  };

  const addCustomerFeedbackToDB = async (customerFeedback) => {
    
    const customerFeedbackNumber= await generateUniqueId("customerFeedbacks",appUserAccountNumber);
    customerFeedback.customerFeedbackNumber = customerFeedbackNumber;

    customerFeedback.appAccountNumber = appUserAccountNumber;
    customerFeedback.applicationMode = applicationMode;

    const docRef = doc(db, 'customerFeedbacks', customerFeedbackNumber);  
    await setDoc(docRef,customerFeedback);

  };

  

  const handleDeleteSelected = async () => {
    if (deleteSelectionModel.length === 0) {
      setDeleteAlertOpen(true);
      return;
    } else 
    {

      setProcessing(true);
      const idsToDelete = [];
      const idsNotToDelete = [];

      let allDeletionDependencies = [];

      //1. Identify Ids to Delete
      for (const id of deleteSelectionModel)
      {
        const dependencies = await hasDependencies(id);
    
        allDeletionDependencies = allDeletionDependencies.concat(dependencies); 

        setProcessing(false);
        
        if (dependencies.length === 0) {
          idsToDelete.push(id);
        } else 
        {
          idsNotToDelete.push(id);
        }
      }

      let uniqueDeletionDependencies = [...new Set(allDeletionDependencies)];

      setDeletionDependencies(uniqueDeletionDependencies);

      setSelectedIdsToDelete(idsToDelete);
      setSelectedIdsNotToDelete(idsNotToDelete);

      //2. Delete allowed ids

      setDeleteConfirmOpen(true);
      setProcessing(false);

    }

  };


  const handleAlertClose = () => {
    setDeleteAlertOpen(false);
  };

  
  const handleCancelDelete = () => {
      
    setDeleteConfirmOpen(false);
    setSelectedIdsToDelete([]);
    setSelectedIdsNotToDelete([]);
    setDeletionDependencies([]);
    
};


  const confirmDeleteSelected = async () => {
    try {
      const batch = writeBatch(db);
      selectedIdsToDelete.forEach(id => {
        const docRef = doc(db, "customerFeedbacks", id);
        batch.delete(docRef);
      });

      await batch.commit();
      logToast("The records have been delete.");

      setDeleteSelectionModel([]);
      setDeleteConfirmOpen(false);
    } catch (error) {
      console.error("Error deleting documents: ", error);
    }
  };

  const openCustomerFeedbackDrawer = (id) => {

    const rowIndex = filteredCustomerFeedbacks.findIndex(row => row.id === id);

    const customerFeedbackId = id;

    setSelectedRowIndex(rowIndex);

    const selectedCustomerFeedback = customerFeedbacks.find(p => p.id === customerFeedbackId);
    if (selectedCustomerFeedback !== null && selectedCustomerFeedback != undefined)
    {  
      setSelectedCustomerFeedback(selectedCustomerFeedback);
      setDrawerOpen(true);
    }
  };

  const handleDrawerClose = () => {
      setDrawerOpen(false);
      setSelectedCustomerFeedback(null);
  };

  const hasDependencies = async (id) => {
    const dependencies = [];
  
    try {
      
      
  
    } catch (error) {
      console.error("Error checking dependencies:", error);
      return ["error"]; // Return an array with "error" to prevent deletion in case of an issue
    }
  
    return dependencies; // Return array of collection names with dependencies
  };
  
  const handleDeleteSingleItem = async (id) => {
  
    try
    {
      
      setProcessing(true);

      const dependencies = await hasDependencies(id);
    
      setProcessing(false);
      
      if (dependencies.length === 0) {
        setDeleteId(id);
        setConfirmOpen(true);
      } else {
        setDeleteId(id);
        setDeletionDependencies(dependencies);
        setDependenciesAlertOpen(true);
      }

    } catch(error)
    {
      setProcessing(false);
    }
  };

  const handleDependenciesAlertClose = async () => {
    
      setDependenciesAlertOpen(false);
      setDeletionDependencies([]);
    
  };


  const handleConfirmClose = async () => {
    try {
      if (deleteId) await deleteDoc(doc(db, "customerFeedbacks", deleteId));
      setConfirmOpen(false);
      setDeleteId("");
      logToast("The record has been delete.");
    } catch (error) {
      console.error("Error deleting document: ", error);
    }
  };

  const handleCancelClose = () => {
    setConfirmOpen(false);
    setDeleteId("");
  };

  const handleOpenEdit = (id) => {

    setEditingCustomerFeedback(customerFeedbacks.find(customerFeedback => customerFeedback.id === id));
    setDrawerOpen(false);
    setShowModal(true); 
  }

  /*
  const filteredCustomerFeedbacks = customerFeedbacks.filter(customerFeedback =>
    columns.some(column => customerFeedback[column.field] && customerFeedback[column.field].toString().toLowerCase().includes(searchTerm.toLowerCase()))
  );
  */
  
  const filteredCustomerFeedbacks = customerFeedbacks.filter(customerFeedback =>
    columns.some(column => {
        let value = customerFeedback[column.field];

        if (column.field.endsWith('Id')) {
            const formatFunctionName = 'format' + column.field.replace(/Id$/, '').replace(/^\w/, c => c.toUpperCase());

            try
            {
              value = eval(`${formatFunctionName}("${value}")`);
            } catch(errr){}
        }

        return value && value.toString().toLowerCase().includes(searchTerm.toLowerCase());
    })
  );



  const totalCustomerFeedbacks = filteredCustomerFeedbacks.length;


  return (
    <div>
      
        <Box m="20px">
          <Header title="Customer Feedbacks By Status" subtitle="List of customer feedbacks" />
          <Box m="0px 0 0px 0" pt="10px" display="flex" >
          
            <Button variant="contained" color="primary" sx={{ backgroundColor: colors.greenAccent[600], color: colors.grey[100], '&:hover': { backgroundColor: colors.greenAccent[800] } }} onClick={handleDeleteSelected} disabled={loading}>
                  <RemoveCircleOutlineIcon /> &nbsp; Delete Selected
                </Button>
              &nbsp;&nbsp;&nbsp;&nbsp;

                <Button variant="contained" color="primary" sx={{ backgroundColor: colors.greenAccent[600], color: colors.grey[100], '&:hover': { backgroundColor: colors.greenAccent[800] } }} onClick={handleOpenModal} disabled={loading}>
                  <AddCircleOutlineIcon /> &nbsp; Add New
                </Button>
          </Box>
          {loading ? (
                <Box display="flex" justifyContent="center" alignItems="center" height="100%">
                  <CircularProgress size={150} style={{ marginTop:'200px',color: theme.palette.mode === "dark" ? 'white' : 'darkGray' }}  />
                </Box>
              ) : (
                <div>
                {customerFeedbacks.length === 0 && (
                  
                  <Box display="flex" alignItems="center" justifyContent="center" height="100%" sx={{ flexDirection: 'column' }}>
                    <img src={noRecordImage} alt="No Data" style={{ width: 250, height: 250, opacity: 0.4 }} />
                    <Typography variant="h4" sx={{ color: colors.grey[300] }}>You don't have any customer feedbacks yet</Typography>
                    <Typography variant="h5" sx={{ color: colors.grey[400], padding: '10px' }}>Click the <span style={{ color: '#dc0000', fontWeight: 'bold' }}>"ADD NEW"</span> button above</Typography>
                  </Box>
                
                )}

                {customerFeedbacks.length > 0 && (
     
                <Box>
                {!isMobile ? (
     
                  <div>
                  
                  <div style={{ paddingTop:'7px',display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                   {/*   <div style={{ flex: '0 0 auto', textAlign: 'left', paddingLeft:'7px', fontSize:'11px' }}>
                          COLUMNS FILTERS
                      </div>
                    */}
                      <div style={{ margin: '0 auto', textAlign: 'center' }}>
                      You can drag and drop items from one column to the other
                      </div>
                  </div>
                  
                  <DndProvider backend={HTML5Backend}>
                    <Box display="flex" mt={1}>  {/* justifyContent="space-around" */}
                    
        <StatusColumn
              title="Pending"
              status="Pending"
              cards={pending}
              moveCard={moveCard} 
              setEditingCustomerFeedback={setEditingCustomerFeedback} 
              setDeleteId={setDeleteId} 
              setConfirmOpen={setConfirmOpen} 
              customerFeedbacks={customerFeedbacks}
              setShowModal={setShowModal} 
              colors={colors} 
              theme={theme} 
              deleteSelectionModel={deleteSelectionModel} 
              setDeleteSelectionModel={setDeleteSelectionModel} 
              titleColor="#000000" 
              setEditingData={setEditingCustomerFeedback} 
              handleDeleteSingleItem={handleDeleteSingleItem}
              setDrawerOpen={setDrawerOpen}
              customerMap={customerMap}
formatCustomer={formatCustomer}
statusColorMap={statusColorMap}

            />
        

        <StatusColumn
              title="Reviewed"
              status="Reviewed"
              cards={reviewed}
              moveCard={moveCard} 
              setEditingCustomerFeedback={setEditingCustomerFeedback} 
              setDeleteId={setDeleteId} 
              setConfirmOpen={setConfirmOpen} 
              customerFeedbacks={customerFeedbacks}
              setShowModal={setShowModal} 
              colors={colors} 
              theme={theme} 
              deleteSelectionModel={deleteSelectionModel} 
              setDeleteSelectionModel={setDeleteSelectionModel} 
              titleColor="#000000" 
              setEditingData={setEditingCustomerFeedback} 
              handleDeleteSingleItem={handleDeleteSingleItem}
              setDrawerOpen={setDrawerOpen}
              customerMap={customerMap}
formatCustomer={formatCustomer}
statusColorMap={statusColorMap}

            />
        

        <StatusColumn
              title="Resolved"
              status="Resolved"
              cards={resolved}
              moveCard={moveCard} 
              setEditingCustomerFeedback={setEditingCustomerFeedback} 
              setDeleteId={setDeleteId} 
              setConfirmOpen={setConfirmOpen} 
              customerFeedbacks={customerFeedbacks}
              setShowModal={setShowModal} 
              colors={colors} 
              theme={theme} 
              deleteSelectionModel={deleteSelectionModel} 
              setDeleteSelectionModel={setDeleteSelectionModel} 
              titleColor="#000000" 
              setEditingData={setEditingCustomerFeedback} 
              handleDeleteSingleItem={handleDeleteSingleItem}
              setDrawerOpen={setDrawerOpen}
              customerMap={customerMap}
formatCustomer={formatCustomer}
statusColorMap={statusColorMap}

            />
        


                    </Box>
                  </DndProvider>
                  </div>

                ) : (    

                  <div className="tile-wrapper">

                  {filteredCustomerFeedbacks.slice(0, visibleCount).map((item, index) => ( 
                        <Tile key={index} data={item} customerFeedbacks={customerFeedbacks} setShowModal={setShowModal} setEditingData={setEditingCustomerFeedback} handleDeleteSingleItem={handleDeleteSingleItem} setCollectionModalOpen={setCollectionModalOpen} setMissingCollections={setMissingCollections} deleteSelectionModel={deleteSelectionModel} setDeleteSelectionModel={setDeleteSelectionModel} />
                       ))}
              
              
                  </div>

                )}
                </Box>

                )}
                

                </div>
            )}
        </Box>


        <CustomerFeedbackDrawerModal
              drawerOpen={drawerOpen}
              handleDrawerClose={handleDrawerClose} 
              handleArrowUpClick="" 
              handleArrowDownClick=""
              selectedCustomerFeedback={editingCustomerFeedback}
              customerFeedbacks={customerFeedbacks} 
              handleOpenEdit={handleOpenEdit}
          />

      <CustomerFeedbackInputModal isOpen={showModal} onClose={() => setShowModal(false)} onSave={handleSaveCustomerFeedback} customerFeedback={editingCustomerFeedback} />

      <Dialog open={confirmOpen} onClose={handleCancelClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
        <DialogTitle id="alert-dialog-title" sx={{ backgroundColor: colors.greenAccent[700] }}>{"Confirm"}</DialogTitle>
        <DialogContent sx={{ backgroundColor: colors.greenAccent[700] }}>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete this customer feedback?
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ backgroundColor: colors.greenAccent[700] }}>
          <Button onClick={handleCancelClose} sx={{ backgroundColor: colors.greenAccent[600], color: colors.primary[100],'&:hover': { backgroundColor: colors.greenAccent[800] } }}>
            No
          </Button>
          <Button onClick={handleConfirmClose} sx={{ backgroundColor: colors.greenAccent[600], color: colors.primary[100],'&:hover': { backgroundColor: colors.greenAccent[800] } }} autoFocus>
            Yes
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={deleteConfirmOpen} onClose={handleCancelDelete} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
        <DialogTitle id="alert-dialog-title" sx={{ backgroundColor: colors.greenAccent[700] }}>{"Confirm Delete"}</DialogTitle>
        <DialogContent sx={{ backgroundColor: colors.greenAccent[700] }}>
          <DialogContentText id="alert-dialog-description">
            
          
            {(selectedIdsToDelete.length > 0 && selectedIdsNotToDelete.length == 0) && 
              <div>Are you sure you want to delete the selected customer feedbacks? </div>
            }

            {(selectedIdsToDelete.length > 0 && selectedIdsNotToDelete.length > 0) && 
              <div>
                The selected customer feedbacks with ids: &nbsp;
                <b>{selectedIdsNotToDelete.join(", ")}</b><br></br> 
                cannot be deleted because they are linked to other dependent records in the following components:<br></br> <br></br>
                <b>{deletionDependencies.join(", ")}</b>. 
                <br></br><br></br>

                However, the remaining customer feedbacks with ids: &nbsp;
                <b>{selectedIdsToDelete.join(", ")}</b><br></br> 
                will be deleted If you select <b>YES</b>. <br></br><br></br>

                Do you want to proceed deleting <b>{selectedIdsToDelete.join(", ")}</b>? 
              </div>
            }

            {(selectedIdsToDelete.length == 0 && selectedIdsNotToDelete.length > 0) && 
              <div>
                The selected customer feedbacks with ids: &nbsp;
                <b>{selectedIdsNotToDelete.join(", ")}</b><br></br> 
                cannot be deleted because they are linked to other dependent records in the following components:<br></br> <br></br>
                <b>{deletionDependencies.join(", ")}</b>. 
                <br></br><br></br>
                Please remove these dependencies before proceeding with the deletion.
                <br></br><br></br>

                <b><u>TIP</u>:</b> You can go to each of the components listed above and type each of the ids listed one by one in the search box to find the dependent records.
              </div>
            }

          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ backgroundColor: colors.greenAccent[700] }}>
          <Button onClick={handleCancelDelete} sx={{ backgroundColor: colors.greenAccent[600], color: colors.primary[100],'&:hover': { backgroundColor: colors.greenAccent[800] } }}>
          {selectedIdsToDelete.length > 0 ? 'No' : 'OK'}
          </Button>
          {selectedIdsToDelete.length > 0 &&
          <Button onClick={confirmDeleteSelected} sx={{ backgroundColor: colors.greenAccent[600], color: colors.primary[100],'&:hover': { backgroundColor: colors.greenAccent[800] } }} autoFocus>
            Yes
          </Button>
          }
        </DialogActions>
      </Dialog>
      
      <Dialog open={collectionModalOpen} aria-labelledby="collection-modal-title" aria-describedby="collection-modal-description">
        <DialogTitle id="collection-modal-title">{"Missing Records"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="collection-modal-description">
            {missingCollections.includes("customers") && <span>Please add at least one <b>customer</b> before managing customer feedbacks. <br></br></span>}

          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button color="primary" sx={{ backgroundColor: colors.greenAccent[600], color: colors.grey[100], '&:hover': { backgroundColor: colors.greenAccent[800] } }}  onClick={() => window.location.href = `/${missingCollections[0]}`} color="primary">
            Go to {missingCollections[0]}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={deleteAlertOpen} onClose={handleAlertClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
        <DialogTitle id="alert-dialog-title" sx={{ backgroundColor: colors.greenAccent[700] }}>{"Alert"}</DialogTitle>
        <DialogContent sx={{ backgroundColor: colors.greenAccent[700] }}>
          <DialogContentText id="alert-dialog-description">
            No customer feedbacks selected for deletion.
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ backgroundColor: colors.greenAccent[700] }}>
          <Button onClick={handleAlertClose} sx={{ backgroundColor: colors.greenAccent[600], color: colors.primary[100],'&:hover': { backgroundColor: colors.greenAccent[800] } }} autoFocus>
            OK
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={dependenciesAlertOpen} onClose={handleDependenciesAlertClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
        <DialogTitle id="alert-dialog-title" sx={{ backgroundColor: colors.greenAccent[700] }}>{"Delete Alert"}</DialogTitle>
        <DialogContent sx={{ backgroundColor: colors.greenAccent[700] }}>
          <DialogContentText id="alert-dialog-description">
          This customer feedback cannot be deleted because it is linked <br></br> 
          to other dependent records in the following components:<br></br> <br></br>
          <b>{deletionDependencies.join(", ")}</b>. 
          <br></br><br></br>
          Please remove these dependencies before proceeding with the deletion.
          <br></br><br></br>

          <b><u>TIP</u>:</b> You can go to each of the components listed above and type <b>{deleteId}</b> in the search box to find the dependent records.
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ backgroundColor: colors.greenAccent[700] }}>
          <Button onClick={handleDependenciesAlertClose} sx={{ backgroundColor: colors.greenAccent[600], color: colors.primary[100],'&:hover': { backgroundColor: colors.greenAccent[800] } }} autoFocus>
            OK
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={showTestModeDialog} onClose={() => setShowTestModeDialog(false)}>
        <DialogTitle sx={{ backgroundColor: colors.greenAccent[700] }}>
          {"Test Mode Notice"}
        </DialogTitle>
        <DialogContent sx={{ backgroundColor: colors.greenAccent[700] }}>
          <DialogContentText>
            You are currently in <strong>Test Mode</strong>. This mode is intended for training and testing purposes only.
            <br /><br />
            If your intention is to add a live project record, please turn off test mode before proceeding.
          </DialogContentText>
          <Box mt={2}>
            <label>
              <input
                type="checkbox"
                checked={suppressTestModeWarning}
                onChange={(e) => {
                  const checked = e.target.checked;
                  setSuppressTestModeWarning(checked);
                  localStorage.setItem('suppressTestModeSaveWarning', checked);
                }}
              />{" "}
              Don't show this message again when saving in test mode
            </label>
          </Box>
        </DialogContent>
        <DialogActions sx={{ backgroundColor: colors.greenAccent[700] }}>
          <Button
            onClick={() => setShowTestModeDialog(false)}
            sx={{
              backgroundColor: colors.greenAccent[600],
              color: colors.primary[100],
              '&:hover': { backgroundColor: colors.greenAccent[800] }
            }}
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>


    {processing && (
    <Box
      position="fixed"
      top={0}
      left={0}
      width="100%"
      height="100%"
      display="flex"
      justifyContent="center"
      alignItems="center"
      zIndex={2000}
      pointerEvents="none"
    >
      <CircularProgress size={120} style={{ color: theme.palette.mode === "dark" ? 'white' : 'darkGray' }} />
    </Box>
  )}

    </div>

  );
};

const StatusColumn = ({ title, status, cards, moveCard, setEditingCustomerFeedback, setDeleteId, setConfirmOpen, customerFeedbacks, setShowModal, colors, theme,deleteSelectionModel,setDeleteSelectionModel,titleColor,setEditingData,handleDeleteSingleItem,setDrawerOpen ,customerMap, formatCustomer,statusColorMap}) => {
  const [, drop] = useDrop({
    accept: ItemType.CARD,
    drop: (item) => {
      moveCard(item, cards.length, status);
    },
  });

  return (
    <Box
    ref={drop}
    sx={{ width: '30%', minHeight: '400px', backgroundColor: colors.dragAndDropDrop.droppableAreaBackgroundColor, padding: 0, marginBottom: 5, borderTopLeftRadius: '10px', borderTopRightRadius: '10px', borderBottomLeftRadius: '4px', borderBottomRightRadius: '4px', marginRight:2 }}
  >
    <Box 
      sx={{
        backgroundColor: titleColor === '#000000' ?  stringToColorLight(title) : titleColor,
        color: titleColor === '#000000' ? '#000000' : '#FFFFFF',
        padding: '0px',
        borderTopLeftRadius: '10px',
        borderTopRightRadius: '10px',
        borderBottomLeftRadius: '0px',
        borderBottomRightRadius: '0px',
        marginBottom: '10px',
        marginTop: '0px',
        marginLeft: '0px',
        marginRight: '0px',
        textAlign: 'center',
        minHeight:'45px',
        paddingTop:'10px'
      }}
    >
      <Typography variant="h5" style={{fontWeight:'600',fontSize:'17px'}}>{title} ({cards.length})</Typography>
    </Box>
      {cards.map((card, index) => (
        <DraggableCard
          key={card.id}
          customerFeedback={card}
          index={index}
          moveCard={(from, to) => moveCard(from, to, status)}
          status={status} 
          setEditingCustomerFeedback={setEditingCustomerFeedback} 
          setDeleteId={setDeleteId} 
          setConfirmOpen={setConfirmOpen} 
          customerFeedbacks={customerFeedbacks} 
          setShowModal={setShowModal} 
          colors={colors} 
          theme={theme} 
          deleteSelectionModel={deleteSelectionModel} 
          setDeleteSelectionModel={setDeleteSelectionModel} 
          setEditingData={setEditingData} 
          handleDeleteSingleItem={handleDeleteSingleItem}
          setDrawerOpen={setDrawerOpen}
          customerMap={customerMap}
formatCustomer={formatCustomer}
statusColorMap={statusColorMap}

        />
      ))}
    </Box>
  );
};


export default CustomerFeedbacks;
